export default __webpack_public_path__ + "static/media/6Vid.d475829f.mp4";